<div class="workspace">
  <div class="infl-container">
    <div class="basic-info-container">
      <div class="row basic-info">
        <div class="col-sm-2 "></div>
        <div class="col-sm-10">
          <div class="campaign-selection-wrapper">
            <div class="campaign-list">
              <achoo-filter-box
                class="full-width"
                placeholder="{{'INFLUENCER.campaign.campaign_list_placeholder' | translate}}"
                [options]="campaignList"
                (selectEvent)="onChangeCampaign($event)"
                [(model)]="selectedCampaignId"
                name="campaignSelection">
              </achoo-filter-box>
            </div>
          </div>
          <div class="campaign-description" *ngIf="selectedCampaign">
            {{selectedCampaign.brief}}
          </div>
          <div class="campaign-tag">
            <achoo-chips
              [chips]="campaignKeywords"
            ></achoo-chips>
          </div>
        </div>
      </div>
    </div>
    <div class="main-infl-content">
      <div class="tab-container">
        <ul class="nav nav-tabs" id="myTab" [ngStyle]="{backgroundColor: platformBackground}" role="tablist">
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': isActiveCampaignTab}"
               data-toggle="tab"
               (click)="showCampaign()"
               role="tab">{{ 'INFLUENCER.CAMPAIGN' | translate }}</a>
          </li>

          <li class="nav-item" *ngIf="isAcivatedAdvertiserChat() && selectedCampaign">
            <a class="nav-link" [ngClass]="{'active': isActiveChatTab}"
               data-toggle="tab"
               (click)="setChatTabSelected()"
               role="tab">{{ 'campaigns.new_campaign.advertiser_chat' | translate }}</a>
          </li>

        </ul>
        <div class="tab-content" *ngIf="isActiveCampaignTab">
          <div>
            <div class="d-flex flex-row">
              <div class="full-width campaign-slider-container">
                <campaign-influencer-status-slider
                  [slider]="campaignSilder"
                  [readonly]="'true'"
                  >
                </campaign-influencer-status-slider>
              </div>
            </div>
            <div class="d-flex flex-row kpi-container">
              <kpi-report
                class="full-width"
                [kpi]="campaignInfluencerKPI"
                [showKpiStatus]="false"
              ></kpi-report>
            </div>
          </div>
          <div class="d-flex flex-row">
            <div class="full-width post-list-container">
              <campaign-influencer-posts
              headerText="{{'measure.platform' | translate}}"
              [posts]="campaignPosts" [readonly]="'true'">

              </campaign-influencer-posts>
            </div>
          </div>

        </div>
        <div class="tab-content" *ngIf="isActiveChatTab && conversation">
          <div class="chat-container">
            <influencer-chat [conversation]="conversation" [showActivityLog]="showActivityLog"></influencer-chat>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="bottombar"
     [ngClass]="{'open': activeBottomBar === true, 'collapsed': activeBottomBar === false}">
  <div class="buttons d-flex flex-auto justify-content-end" >
    <button class="button gray" (click)="exportPDF()">{{'common.btn.export' | translate}}</button>
    <button class="button red back" (click)="backToCampaignOverview()">{{'common.btn.back' | translate}}</button>
  </div>
</div>

<achoo-popup #AlertPdfDownloadPending
             [isNotification]="true"
             modelTitle="{{'common.alert' | translate}}"
             (acceptCallback)="closeNotification()"
             (cancelCallback)="closeNotification()">
  <span>{{'pdf.pending_message' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-campaign-detail/influencer-campaign-detail.component.html